:host {
  ::slotted(*) {
    width: 100%;
  }
}

.stzh-company-logo {
  @include spaceCurve('padding-top', 'huge');
  @include spaceCurve('padding-bottom', 'large');
  @include container;
  display: flex;
  justify-content: flex-end;
  width: inherit;

  &__image {
    width: 150px;
  }
}
